// extracted by mini-css-extract-plugin
export default {"pullDownButtons":"tabs_pullDownButtons__7Sdek"};